/***
 * Created on 2024/7/16
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ReactDom from "react-dom";
import ic_sys_error_svg from '../../../static/img/utils/ic_sys_error.svg';
import {useTranslation} from "react-i18next";

function ModalErrorComponent({isOpen, onClose, error_title, children}) {
    const { t } = useTranslation();

    return ReactDom.createPortal(
        <>
            {isOpen && <div className="screen-mask visible"/> }
            {isOpen &&
                <div className="dialog-wrapper">
                    <div className="dialog dialog-alert-msg">
                        <div className="dialog-header">
                            <div className="close" onClick={()=>onClose(false)}></div>
                        </div>
                        <div className="dialog-body">
                            <div className="alert-ic">
                                <img src={ic_sys_error_svg} alt=""/>
                            </div>
                            <div className="dialog-content">
                                <div className="alert-msg-inner-head">{error_title}</div>
                                {children}
                            </div>
                        </div>
                        <div className="dialog-footer clear">
                            <div className="pull-right">
                                <div className="q-btn-group">
                                    <button type="button" className="q-btn q-btn-primary" onClick={()=>onClose(false)}>{t('@OK@')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>,
        document.getElementById('modal-dialog')
    )
}

export default ModalErrorComponent;